import md5 from 'md5'

var encrypt = function (params) {
    var Param = params;
    // Param.sTime = parseInt(new Date().getTime() / 1000);
    //先用Object内置类的keys方法获取要排序对象的属性名，再利用Array原型上的sort方法对获取的属性名进行排序，sortArr是一个数组
    var sortKeyArr = Object.keys(params).sort();
    var sortArr = [], sortStr;

    sortKeyArr.forEach(function (item, index) {
        sortArr[index] = item + '=' + params[item]
    })

    sortStr = sortArr.join('&');
    Param.sign = md5(sortStr);
    Param.privateSign = md5(`${sortStr}fc925488f745a1c5d370111afa53e8ce`);
    return Param
}


export default encrypt



// WEBPACK FOOTER //
// ./src/components/plugin/lib/encrypt.js